import React from "react";

export const UploadingSubmission: React.FC = () => {
  const perleRedColor = "#DC2626"; // Example: Tailwind's red-600

  const styles: { [key: string]: React.CSSProperties } = {
    container: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      height: "70vh", // Adjust as needed
      textAlign: "center",
      // Add other styles similar to submission-successful.tsx here
    },
    spinnerContainer: {
      marginBottom: "20px",
    },
    spinner: {
      border: `4px solid rgba(0, 0, 0, 0.1)`, // Light grey border
      borderLeftColor: perleRedColor, // Spinner color
      borderRadius: "50%",
      width: "50px",
      height: "50px",
      animation: "spin 1s linear infinite",
    },
    text: {
      fontSize: "1.2em",
      color: perleRedColor, // Text color
    },
  };

  // Ensure the spin animation is injected only once
  if (typeof window !== "undefined") {
    const animationName = "spin";
    let styleSheet = document.styleSheets[0];
    let ruleExists = false;

    if (styleSheet) {
      try {
        for (let i = 0; i < styleSheet.cssRules.length; i++) {
          const rule = styleSheet.cssRules[i] as CSSKeyframesRule;
          if (rule.name === animationName) {
            ruleExists = true;
            break;
          }
        }
      } catch (e) {
        // Catch potential security errors when accessing cssRules from different origins
        console.warn(
          "Could not access CSS rules, creating new style tag for animation",
          e,
        );
        styleSheet = undefined as any; // Force creation of a new style tag
      }
    }

    if (!ruleExists) {
      let ss = styleSheet ? null : document.createElement("style");
      const animationRule = `
          @keyframes ${animationName} {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `;
      if (ss) {
        ss.innerHTML = animationRule;
        document.head.appendChild(ss);
      } else if (styleSheet) {
        try {
          styleSheet.insertRule(animationRule, styleSheet.cssRules.length);
        } catch (e) {
          console.error("Error inserting CSS rule:", e);
          // Fallback if insertRule fails (e.g. in some shadow DOM scenarios or strict CSP)
          ss = document.createElement("style");
          ss.innerHTML = animationRule;
          document.head.appendChild(ss);
        }
      }
    }
  }

  return (
    <div style={styles.container}>
      <div style={styles.spinnerContainer}>
        <div style={styles.spinner}></div>
      </div>
      <p style={styles.text}>uploading...</p>
    </div>
  );
};
